import { render } from "./liveChat.vue?vue&type=template&id=a4975fa8"
import script from "./liveChat.vue?vue&type=script&lang=js"
export * from "./liveChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__